import { useCallback } from 'react';
import { trackButtonClick, trackAddToCart, trackFavorite, trackNavigation, trackEvent } from '../utils/analytics';

/**
 * Custom hook for easy analytics tracking
 * Usage:
 *   const { trackClick, trackCart, trackFav, trackNav } = useAnalytics();
 *   <button onClick={() => trackClick('Button Name')}>Click</button>
 */
export const useAnalytics = () => {
  const trackClick = useCallback((buttonName, additionalParams = {}) => {
    trackButtonClick(buttonName, additionalParams);
  }, []);

  const trackCart = useCallback((item) => {
    trackAddToCart(item);
  }, []);

  const trackFav = useCallback((item, isAdding) => {
    trackFavorite(item, isAdding);
  }, []);

  const trackNav = useCallback((destination, linkText) => {
    trackNavigation(destination, linkText);
  }, []);

  const track = useCallback((eventName, eventParams = {}) => {
    trackEvent(eventName, eventParams);
  }, []);

  return {
    trackClick,
    trackCart,
    trackFav,
    trackNav,
    track
  };
};

